import { render } from "./WritingQuestion.vue?vue&type=template&id=2220297e&scoped=true&ts=true"
import script from "./WritingQuestion.vue?vue&type=script&lang=ts"
export * from "./WritingQuestion.vue?vue&type=script&lang=ts"

import "./WritingQuestion.vue?vue&type=style&index=0&id=2220297e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2220297e"]])

export default __exports__